import {
  getContactDisplayName,
  getContactShortAddress,
} from '@/components/postgrid/common/contactUtils';
import { Badge } from '@/components/ui/catalyst/badge';
import type { ReadPostgridContact } from '@/services/api/generated/postgridService';

interface ContactComboboxItemProps {
  contact: ReadPostgridContact;
}

/**
 * Minimalist contact item for use within Command/Combobox.
 * Shows only name and address - optimized for performance.
 */
export const ContactComboboxItem: React.FC<ContactComboboxItemProps> = ({
  contact,
}) => {
  const displayName = getContactDisplayName(contact);
  const address = getContactShortAddress(contact);

  return (
    <div className="flex items-center justify-between gap-2 min-w-0">
      <div className="flex-1 min-w-0">
        <div className="font-medium text-sm truncate">{displayName}</div>
        {address && (
          <div className="text-xs text-muted-foreground truncate">
            {address}
          </div>
        )}
      </div>
      {!contact.live && (
        <Badge color="yellow" className="text-xs shrink-0">
          Test
        </Badge>
      )}
    </div>
  );
};
